import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'
import router from '@/router/'
import VueJWT from 'vuejs-jwt'
import authService from '@/services/authService'
/* eslint-disable */
import { createAsyncMutations } from '@/stores/mutation-types'
import { doAsync, authAsync } from '@/stores/async-util'
import types from '@/stores/types'

Vue.use(Vuex)
Vue.use(VueJWT)

const state = {
  user: null,
  auth: Vue.$jwt.decode(localStorage.getItem('access_token')),
  isLoggedIn: authService.isLoggedIn(),
  dashboard: null,
  userKits: null,
  userSurveys: null,
}

const postLogin = createAsyncMutations(types.POST_LOGIN, state)
const postRefresh= createAsyncMutations(types.POST_REFRESH, state)
const getUserMutations = createAsyncMutations(types.GET_USER, state)
const postUserMutations = createAsyncMutations(types.POST_USER, state)
const putUserMutations = createAsyncMutations(types.PUT_USER, state)
const getResetPassword = createAsyncMutations(types.GET_RESET_PASSWORD, state)
const postResetPassword = createAsyncMutations(types.POST_RESET_PASSWORD, state)
const postEmailVerification = createAsyncMutations(types.POST_EMAIL_VERIFICATION, state)
const postParentalConsent = createAsyncMutations(types.POST_PARENTAL_CONSENT, state)
const postParentalConsentEmail = createAsyncMutations(types.POST_PARENTAL_CONSENT_EMAIL, state)
const kitMutations = createAsyncMutations(types.GET_KITS, state)
const subscriptionMutations =createAsyncMutations(types.GET_SUBSCRIPTIONS, state)
const sentKitMutations = createAsyncMutations(types.GET_SENT_KITS, state)
const kitActivation = createAsyncMutations(types.POST_KIT_ACTIVATION, state)
const dashboardMutations = createAsyncMutations(types.GET_DASHBOARD, state)
const orderMutations = createAsyncMutations(types.POST_ORDER, state)
const getSurveyMutations = createAsyncMutations(types.GET_SURVEY, state)
const getToken = createAsyncMutations(types.GET_TOKEN, state)
const getKitTimelineMutations = createAsyncMutations(types.GET_KIT_TIMELINE, state)
const getRecruitmentConsent = createAsyncMutations(types.GET_RECRUITMENT_CONSENT, state)
const postRecruitmentCandidate = createAsyncMutations(types.POST_RECRUITMENT_CANDIDATE, state)
const putRecruitmentCandidateConsent = createAsyncMutations(types.PUT_RECRUITMENT_CANDIDATE_CONSENT, state)

const authMutations = {

  LOGIN_SUCCESS (state) {
    state.isLoggedIn = true
    state.pending = false
    router.push('profile')
  },
  LOGOUT (state) {
    state.isLoggedIn = false
    router.push('/')
  }
}

const actions = {

  login: (context, payload) => {
    return authAsync(context, {
      url: 'oauth/token',
      mutationType: types.POST_LOGIN,
      method: 'POST',
      data: qs.stringify({
        grant_type: 'password',
        username: payload.email,
        password: payload.password,
        client_id: process.env.API_USER
      })
    }).then(response => {
      authService.setAccessTokenExpiration(response.data.expires_in)
      authService.setAccessToken(response.data.access_token)
      authService.setRefreshToken(response.data.refresh_token)
      Vue.set(state, 'user', response.data.user_id)

      // let redeemObj = localStorage.getItem('redeem_on_register')
      // if (redeemObj) {
      //   let obj = JSON.parse(redeemObj)
      //
      //   console.log("Redeem kit", obj)

        // context.dispatch('joinResearch', {
        //   'participantIdentifier': obj.participantIdentifier,
        //   'userId': response.data.user_id
        // }).then(success => {
        //   console.log('Project', success)
        //
        //   context.dispatch('checkVoucher', { voucher: obj.voucherCode }).then(success => {
        //     let kit = success.data
        //     console.log('kit', success)
        //
        //     context.dispatch('redeemKit', {
        //       kitId: kit.id,
        //       addressLine1: '',
        //       addressLine2: '',
        //       suburb: '',
        //       state: '',
        //       postcode: '',
        //       voucher: obj.voucherCode,
        //       activate: false
        //     }).then(success => {
        //       console.log('Voucher redeemed', success)
        //     }).catch(error => { console.log('Cant redeem voucher', error) });
        //
        //   }).catch(error => { console.log('Cant verify voucher code', error) });
        //
        // }).catch(error => { console.log('Cant join project', error) });



      // }

      router.push('dashboard')
    })
  },

  refreshToken: (context, payload) => {
    authAsync(context, {
      url: 'oauth/refresh',
      mutationType: types.GET_DASHBOARD,
      method: 'POST',
      data: qs.stringify({
        grant_type: 'password',
        username: payload.email,
        password: payload.password,
        client_id: process.env.API_USER
      }),
      postSuccess: (data) => {
        authService.setAccessTokenExpiration(data.expires_in)
        authService.setAccessToken(data.access_token)
      }
    })
  },

  logout: context => {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('vuex')
    window.location.reload(false)
    context.commit('LOGOUT')
  },

  getDashboard: context => {
    authService.getUserID()
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/dashboard',
      mutationType: types.GET_DASHBOARD
    })
  },

  getUser: (context) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID(),
      mutationType: types.GET_USER
    })
  },

  postUser: (context, payload) => {
    return doAsync(context, {
      url: '/public/registration/',
      method: 'POST',
      mutationType: types.POST_USER,
      data: payload
    })
  },

  putUser: (context, data) => {
    const user = data
    if (user.password === null || user.newPassword === null) {
      delete user.password
      delete user.newPassword
    }
    return doAsync(context, {
      url: 'user/' + authService.getUserID(),
      method: 'PUT',
      mutationType: types.PUT_USER,
      data: user
    })
  },

  postRecruitmentCandidate: (context, payload) => {
    return doAsync(context, {
      url: `public/recruitment/${payload.recruitmentId}/candidate?email=${payload.sendEmail}`,
      method: `POST`,
      mutationType: types.POST_RECRUITMENT_CANDIDATE,
      data: payload
    })
  },

  putRecruitmentCandidateConsent: (context, payload) => {
    return doAsync(context, {
      url: `public/recruitment/${payload.recruitmentId}/candidate/${payload.candidateId}/consent/${payload.consentId}`,
      method: 'PUT',
      mutationType: types.PUT_RECRUITMENT_CANDIDATE_CONSENT,
      data: payload
    })
  },

  postProjectRegister: (context, payload) => {
    return doAsync(context, {
      url: '/public/research/pre-registration',
      method: 'POST',
      data: payload
    })
  },

  getProject: (context, payload) => {
    return doAsync(context, {
      url: 'research-project/' + payload.id,
      method: 'GET',
    })
  },

  getPasswordReset: (context, email) => {
    return doAsync(context, {
      url: '/public/reset-password?username=' + email,
      mutationType: types.GET_RESET_PASSWORD
    })
  },

  getPasswordResetResearch: (context, email) => {
    return doAsync(context, {
      url: '/public/reset-password?username=' + email + '&user-type=RESEARCH',
      mutationType: types.GET_RESET_PASSWORD
    })
  },

  postPasswordReset: (context, payload) => {
    return doAsync(context, {
      url: '/public/reset-password',
      method: 'POST',
      mutationType: types.POST_RESET_PASSWORD,
      data: payload
    })
  },

  postEmailVerification: (context, payload) => {
    return doAsync(context, {
      url: '/public/email-verification/' + payload,
      method: 'POST',
      mutationType: types.POST_EMAIL_VERIFICATION,
    })
  },

  postParentalConsentForm: (context, payload) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/parental-consent',
      method: 'POST',
      data: payload,
      mutationType: types.POST_PARENTAL_CONSENT,
    })
  },

  postParentalConsentEmail: (context, payload) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/parental-consent?email=' + payload,
      method: 'POST',
      mutationType: types.POST_PARENTAL_CONSENT_EMAIL,
    })
  },

  getUserKits: context => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/kits',
      mutationType: types.GET_KITS
    })
  },

  getUserSubscription: context => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/subscriptions',
      mutationType: types.GET_SUBSCRIPTIONS
    })
  },

  getUserSingleSubscription: (context, payload) => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/subscription/' + payload.subscription,
      method: 'GET',
    })
  },

  cancelUserSubscription: (context, payload) => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/subscription/' + payload.subscription,
      method: 'DELETE',
    })
  },

  getUserCard: (context, payload) => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/card',
      method: 'GET',
    })
  },

  getResearchKits: context => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/research-projects',
      mutationType: types.GET_KITS
    })
  },

  getSentKits: context => {
    return doAsync(context, {
      url: 'user/' +authService.getUserID() + '/kit-send-requests',
      mutationType: types.GET_SENT_KITS
    })
  },

  updateKit: (context, payload) => {
    return doAsync(context, {
      url: `kit/${payload.kitId}`,
      method: 'PUT',
      data: {
        kitId: payload.kitId,
        reportReceived: payload.reportReceived
      }
    })
  },

  activateKit: (context, payload) => {
    return doAsync(context, {
      url: 'kit/' + payload.kitId + '/shipping',
      method: 'POST',
      data: payload
    })
  },

  checkReferralCode: (context, payload) => {
    return doAsync(context, {
      url: 'public/microba-informed-professional/' + payload,
      method: 'GET'
    })
  },

  getPromoCode: (context, promoCode) => {
    return doAsync(context, {
      url: `public/promo-code/${promoCode}?product-type=CONSUMER`,
      method: 'GET'
    })
  },

  checkVoucher: (context, payload) => {
    return doAsync(context, {
      url: 'kit/voucher-code/' + payload.voucher,
      method: 'GET'
    })
  },

  checkResearchVoucher: (context, payload) => {
    return doAsync(context, {
      url: 'research/project/voucher-code/' + payload.voucher,
      method: 'GET'
    })
  },

  joinResearch: (context, payload) => {
    return doAsync(context, {
      url: 'research/participant',
      method: 'POST',
      data: payload
    })
  },

  updateCard: (context, payload) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/card?stripeToken='+payload,
      method: 'POST'
    })
  },

  // POST /user/{id}/kit?redeem-voucher-code=[VoucherCodeHere]
  redeemKit: (context, payload) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/kit?redeem-voucher-code=' + payload.voucher + '&activate=' + payload.activate,
      method: 'POST',
      data: payload
    })
  },
  redeemKitBasic: (context, payload) => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/kit?redeem-voucher-code=' + payload.voucher,
      method: 'POST',
      data: null
    })
  },

  // TODO: POST /kit/{id}/voucher-code?to={email}
  sendKit: (context, payload) => {
    return doAsync(context, {
      url: 'kit/' + payload.kitId + '/voucher-code?to=' + payload.email,
      method: 'POST',
      data: payload
    })
  },

  getVoucher: (context, payload) => {
    return doAsync(context, {
      url:`kit/${payload.kitId}/voucher-code`
    })
  },

  getUserSurveys: context => {
    return doAsync(context, {
      url: 'user/' + authService.getUserID() + '/surveys',
      mutationType: types.GET_SURVEY
    })
  },

  getRecruitmentConsent: (context, payload) => {
    return doAsync(context, {
      url: `public/recruitment/${payload.recruitmentId}/candidate/${payload.candidateId}/consent/${payload.consentId}`,
      mutationType: types.GET_RECRUITMENT_CONSENT
    })
  },

  getSurveyAnswers: (context, data) => {
    return doAsync(context, {
      url: 'kit/' + data.kitId  + '/survey/' + data.type
    })
  },

  getSurveyQuestions: (context, type) => {
    return doAsync(context, {
      url: 'survey/' + type
    })
  },

  putSurveyQuestion: (context, data) => {
    return doAsync(context, {
      url: 'kit/' + data.kitId + '/survey',
      method: 'PUT',
      data: data.result
    })
  },

  putKit: (context, data) => {
    return doAsync(context, {
      url: 'kit/' + data.id,
      method: 'PUT',
      data: data
    })
  },

  postOrder: (context, payload) => {
    return doAsync(context, {
      url: 'public/order',
      method: 'POST',
      mutationType: types.POST_ORDER,
      data: payload
    }).then(response => {
      if (response.data) {
        return response
      }
    })
  },

  getKitTimeline: (context, payload) => {
    return doAsync(context, {
      url: `kit/${payload}/timeline`,
      mutationType: types.GET_KIT_TIMELINE
    })
  },

  getToken: (context, username) => {
    doAsync(context, {
      url: 'auth/token?username=' + username,
      mutationType: types.GET_TOKEN
    }).then(response => {
      authService.setAccessTokenExpiration(response.data.expires_in)
      authService.setAccessToken(response.data.access_token)
      authService.setRefreshToken(response.data.refresh_token)
      Vue.set(state, 'user', response.data.user_id)
      router.push('dashboard')
    }).catch(error => {
      // console.log(error)
    })
  }

}

export default new Vuex.Store({
  state,
  mutations: {
    ...postLogin,
    ...postRefresh,
    ...putUserMutations,
    ...postUserMutations,
    ...getUserMutations,
    ...getResetPassword,
    ...postResetPassword,
    ...postEmailVerification,
    ...postParentalConsent,
    ...postParentalConsentEmail,
    ...kitMutations,
    ...subscriptionMutations,
    ...sentKitMutations,
    ...kitActivation,
    ...dashboardMutations,
    ...orderMutations,
    ...getSurveyMutations,
    ...authMutations,
    ...getToken,
    ...getKitTimelineMutations,
    ...postRecruitmentCandidate,
    ...getRecruitmentConsent,
    ...putRecruitmentCandidateConsent
  },
  actions
})




// WEBPACK FOOTER //
// ./src/stores/index.js